import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentEditorPersonalizationContext = /*#__PURE__*/createContext({
  openPanel: () => {
    throw new Error('ContentEditorPersonalizationProvider not found');
  },
  isPanelOpen: false,
  assetData: undefined,
  loading: false,
  error: undefined
});
export const ContentEditorPersonalizationContextProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ContentEditorPersonalizationContext.Provider, {
    value: props,
    children: children
  });
};
export const useContentEditorPersonalizationContext = () => useContext(ContentEditorPersonalizationContext);